import {Props} from './model';
import * as React from 'react';
import {View, StyleSheet} from 'react-native';
import {Modal} from '../modal';
import {useStyles} from '../../../hooks/styles';
import {Button} from '../../button';
import {DeviceSize} from '../../../theme/helpers';
import {Text} from '../../text';
import {useDimensions} from '../../../hooks/useDimensions';

const fl = StyleSheet.flatten;

export default (props: Props) => {
  const {width} = useDimensions();
  const {wrapStyle, overlayStyle, titleStyle, hideCloseButton} = props;
  const styles = useStyles(({theme, mediaOnly}) => {
    return {
      container: {
        alignItems: 'center',
        ...mediaOnly(
          DeviceSize.desktop,
          {
            paddingHorizontal: 110,
            paddingVertical: 40,
            width: 466,
          },
          {
            paddingHorizontal: 40,
            paddingTop: 42,
            paddingBottom: 30,
            width: 328,
            maxWidth: width,
          },
        ),
      },
      title: {
        textAlign: 'center',
        ...mediaOnly(
          DeviceSize.desktop,
          {...theme.fonts.h3, width: 330, maxWidth: 330},
          {...theme.fonts.h6, width: 239, maxWidth: 239},
        ),
        marginBottom: 50,
        flexShrink: 1,
      },
      buttons: {
        alignItems: 'center',
      },
      button: {
        ...mediaOnly(DeviceSize.desktop, {width: 240}, {width: 200}),
        marginBottom: 10,
      },
      content: {
        paddingTop: 0,
      },
    };
  });
  return (
    <Modal
      onClose={props.onClose}
      wrapStyle={{...fl(styles.container), ...fl(wrapStyle)}}
      contentStyle={styles.content}
      titleStyle={titleStyle}
      overlayStyle={overlayStyle}
      hideCloseButton={hideCloseButton}>
      <Text testID='message-modal-id' style={[styles.title, props.messageStyle]}>
        {props.message}
      </Text>
      <View style={styles.buttons}>
        {props.actions.map((action, i) => (
          <View key={i}>
            <Button
              id={`dialog-action-${i}`}
              style={styles.button}
              text={action.title}
              type={action.type}
              onPress={() => {
                if (props.onClose) {
                  props.onClose();
                }
                if (action.onPress) {
                  action.onPress();
                }
              }}
            />
          </View>
        ))}
      </View>
    </Modal>
  );
};
